import type React from 'react';
import { Divider, FormField, Input, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../../models';
import { WATER_BILLING } from '../../../../constants';
import WaterBilling from './WaterBilling';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WaterBilling_v2({ setSectionValues, section }: Props) {
  function onLateFeeChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.LATE_FEES]: value,
    });
  }
  function onProviderChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.PROVIDER]: value,
    });
  }
  function onChargesChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WATER_BILLING.FIELD_NAME.CHARGES]: value,
    });
  }
  return (
    <WaterBilling section={section} setSectionValues={setSectionValues}>
      <>
        <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />
        <FormField
          required
          css={{ marginBottom: 'layout.tight' }}
          label={<Label>What administrative fees or late fees will be assessed?</Label>}
          control={
            <Textarea
              value={section.getFieldValue(WATER_BILLING.FIELD_NAME.LATE_FEES)}
              onChange={onLateFeeChange}
              css={{ resize: 'vertical' }}
            />
          }
        />
        <FormField
          css={{ marginBottom: 'layout.tight' }}
          optional
          label={<Label>Who is the submeter billing provider that will provide the submeter billing service?</Label>}
          control={
            <Input value={section.getFieldValue(WATER_BILLING.FIELD_NAME.PROVIDER)} onChange={onProviderChange} />
          }
        />
        <FormField
          required
          css={{ marginBottom: 'layout.tight' }}
          label={
            <Label>
              How will the submeter bills, including fixed charges and variable charges, be calculated and apportioned?
            </Label>
          }
          control={
            <Textarea
              value={section.getFieldValue(WATER_BILLING.FIELD_NAME.CHARGES)}
              onChange={onChargesChange}
              css={{ resize: 'vertical' }}
            />
          }
        />
      </>
    </WaterBilling>
  );
}

WaterBilling_v2.description = 'Asks if the unit has a water submeter with additional fields for San Diego';

export default WaterBilling_v2;
